<div class="page-header mb-5 p-0">
  <div class="p-5">
    <h3 class="font-weight-bold pb-3" *ngIf="this.status === 'update-user'">Urejanje uporabnika</h3>
    <h3 class="font-weight-bold pb-3" *ngIf="this.status === 'add-user'">Dodaj uporabnika</h3>
    <button class="btn btn-link pl-0" (click)="goBack()"> <i class="fas fa-chevron-left"></i> Nazaj na iskanje</button>
  </div>
</div>
<div class="container-fluid pl-5 pr-5">
  <szz-user-edit [userId]="this.userId" [status]="this.status"></szz-user-edit>
</div>